import React from 'react'
import { Segment, Header, Icon } from 'semantic-ui-react'

export const NoFilesPlaceholder = () => (
  <Segment placeholder>
    <Header icon>
      <Icon name="file alternate outline" color="yellow" />
      <br />
      No files are found here, upload some!
    </Header>
  </Segment>
)
